<script>

export default {
    props: {
        headerRows: {
            type: Number,
            default: 0
        },
        headerCells: {
            type: Number,
            default: 1
        },
        bodyRows: {
            type: Number,
            default: 1
        },
        bodyCells: {
            type: Number,
            default: 1
        }
    }
}
</script>
<template>
    <div class="fake">
        <div class="fake__content">
            <div v-for="index in headerRows"
                 :key="'fake-header-row__' + index"
                 class="fake__header-row">
                <div v-for="index in headerCells"
                     :key="'fake-header-cell__' + index"
                     :style="{width: (100 / headerCells) + '%'}"
                     class="fake__header-cell"/>
            </div>
            <div v-for="index in bodyRows"
                 :key="'fake-body-row__' + index"
                 class="fake__body-row">
                <div v-for="index in bodyCells"
                     :key="'fake-body-cells__' + index"
                     :style="{width: (100 / bodyCells) + '%'}"
                     class="fake__body-cell"/>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/Fake/Fake.vue